import React from 'react';
import loadable from '@loadable/component';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Divider } from '@eb/eds-divider';

import {
    isNextDisabled,
    hasEventResults,
    getTrendingSearchData,
} from './selectors';

import { TrendingSearchesAnchor } from './components/TrendingSearchesAnchor';

import './SearchPivotsContainer.scss';

const SearchPivotSuggestions = loadable(() =>
    import('./SearchPivotSuggestionsContainer'),
);

/**
 * Suggested actions for the user to take given low, empty, or
 * end of search results.
 *
 * Always displays the trending searches footer.
 *
 * @param {*} props
 */
export const SearchResultsPivots = (props) => {
    const { isLoading, hasEventResults, isNextDisabled } = props;
    const shouldRenderSuggestions =
        !isLoading && (!hasEventResults || isNextDisabled);

    return (
        <div className="search-result-pivots">
            {shouldRenderSuggestions && <SearchPivotSuggestions />}
            <div className="eds-l-pad-top-6 eds-l-pad-bot-10">
                <Divider color="ui-200" />
                <TrendingSearchesAnchor
                    trendingSearchData={props.trendingSearchData}
                />
            </div>
        </div>
    );
};

const _mapStateToProps = (state) => ({
    isLoading: state.pagination.loading,
    isNextDisabled: isNextDisabled(state),
    hasEventResults: hasEventResults(state),
    trendingSearchData: getTrendingSearchData(
        state.location,
        state.app.domain,
        state.shouldShowTrendingSearchPageLink,
    ),
});

const enhance = compose(connect(_mapStateToProps));

export const SearchPivotsContainer = enhance(SearchResultsPivots);
